import React from "react";
import MediaQuery from "react-responsive";

import { menuStyles } from "@common/styles";
import Menu from "./menu";
import { IChildContainerProps } from "./home";

const small: React.StatelessComponent<IChildContainerProps> = ({
  children,
  handleMobileMenu,
  showMobileMenu
}) => (
  <MediaQuery maxDeviceWidth={1023}>
    <div
      style={menuStyles.flexColumnWrapper as any}
      className="flexColumnWrapper"
    >
      <div>
        <div
          style={menuStyles.mobileTopContainer as any}
          onClick={handleMobileMenu}
          className="mobileTopContainer"
        >
          <div style={{ marginTop: 30, marginBottom: 20 }}>
            <img style={menuStyles.logo} src="/images/logo.png" />
          </div>
          <div>
            <div style={menuStyles.mobileMenuIcon as any} />
          </div>
        </div>
        <div>{showMobileMenu && <Menu />}</div>
      </div>
      <div>{children}</div>
    </div>
  </MediaQuery>
);

export default small;
